import {
  FETCH_USERINFO_LOADING,
  FETCH_USERINFO_SUCCESS,
  FETCH_USERINFO_FAILED,
  FETCH_USERLOGINLIST_LOADING,
  FETCH_USERLOGINLIST_SUCCESS,
  FETCH_USERLOGINLIST_FAILED,
  FETCH_DEVICELIST_LOADING,
  FETCH_DEVICELIST_SUCCESS,
  FETCH_DEVICELIST_FAILED,


  FETCH_WRITEOFFf_LOADING,
  FETCH_WRITEOFFf_SUCCESS,
  FETCH_FAMILYLIST_SUCCESS
} from "../actions/queryUser";

const defVal = {
  loading: false,
  userInfo: {},
  loginList: [],
  loginPageTotal: 0,
  deviceList: [],
  devicePageTotal: 0,


  writeOffLoading: false,
  writeOffData: [],
  writeOffTotal: 0,
  familyList: [],
  familyPageTotal: 0,
};

export default (state = defVal, action) => {
  switch (action.type) {
    case FETCH_USERINFO_LOADING:
      return Object.assign({}, state, {
        loading: true,
      });
    case FETCH_USERINFO_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        userInfo: action.userInfo,
      });
    case FETCH_USERINFO_FAILED:
      return Object.assign({}, state, {
        loading: false,
      });
    case FETCH_USERLOGINLIST_LOADING:
      return Object.assign({}, state, {
      });
    case FETCH_USERLOGINLIST_SUCCESS:
      return Object.assign({}, state, {
        loginList: action.loginList,
        loginPageTotal: action.loginPageTotal,
      });
    case FETCH_USERLOGINLIST_FAILED:
      return Object.assign({}, state, {
      });
    case FETCH_DEVICELIST_LOADING:
      return Object.assign({}, state, {
      });
    case FETCH_DEVICELIST_SUCCESS:
      return Object.assign({}, state, {
        deviceList: action.deviceList,
        devicePageTotal: action.devicePageTotal,
      });
    case FETCH_DEVICELIST_FAILED:
      return Object.assign({}, state, {
      });




    case FETCH_WRITEOFFf_LOADING:
      return Object.assign({}, state, {
        writeOffLoading: action.status,
      });

    case FETCH_WRITEOFFf_SUCCESS:
      return Object.assign({}, state, {
        writeOffLoading: false,
        writeOffData: action.data,
        writeOffTotal: action.total,
      });

    case FETCH_FAMILYLIST_SUCCESS:
      return Object.assign({}, state, {
        familyList: action.familyList,
        familyPageTotal: action.familyPageTotal,
      });

    default:
      return state;
  }
};
